define('components/course/models/slide-type/quick-tip',[
    'components/course/models/slide-type/base'
], function (Base) {
    "use strict";

    return Base;
});

